<div class="sb-header__breadcrumbs py-4">
  <ng-container *ngFor="let link of links; last as isLast">
    <a class="cursor-pointer primary-blue-color animate-fade-in"
       *ngIf="link.url" [routerLink]="link.url">{{ link.label }}</a>
    <span *ngIf="!link.url" class="primary-blue-color animate-fade-in">{{ link.label }}</span>
    <span class="mx-2 animate-fade-in" *ngIf="!isLast">></span>
  </ng-container>
</div>
